import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface LeftCheckbox {
  id: string;
  label: string;
  checked: boolean;
}

@Component({
  selector: 'itax-left-checkbox',
  templateUrl: './left-checkbox.component.html',
  styleUrls: ['./left-checkbox.component.scss']
})
export class LeftCheckboxComponent implements OnInit {

  @Input() id: string;
  @Input() label: string;
  @Input() image: string;
  @Input() cssClass: string;
  @Input() isSmall = false;
  @Input() isBig = false;
  @Input() hasBadge = false;
  @Input() index: number;
  @Input() color: string;
  @Input() labelWidth = 0;
  @Input() warning = false;
  @Input() checked: boolean;
  @Input() readonly: boolean = false;
  @Input() disabled: boolean = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  @Output() valueChange = new EventEmitter<LeftCheckbox>();


  constructor() {
  }

  ngOnInit(): void {
  }

  onCheckChange(): void {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
    this.valueChange.emit({
      id: this.id,
      label: this.label,
      checked: this.checked
    });
  }

}
